<h4>Historique de vos relevés <fa-icon [icon]="faInfoCircle" [title]="'Sur la période sélectionnée'"></fa-icon></h4>
@if (relevesIndividuels) {
  <div>
    <ul>
      @for (releve of relevesIndividuels; track releve) {
        <li style="border-bottom-color: {{ energieService.getColor(releve.energie)}};">
          <div class="d-flex align-items-center">
            <div class="icon-container d-flex align-self-stretch align-items-center justify-content-center" style="background-color: {{ energieService.getColor(releve.energie)}};">
              <div class="d-flex">
                <span class="icon {{ releve.energie | energieIcon }}" title="{{ releve.energie | energieName }}"></span>
              </div>
            </div>
            <div class="value-container">
              {{ releve.date | date }}<br />
              {{ releve.valeur }} <span [innerHTML]="energieService.getUnite(releve.energie)"></span>
            </div>
            <div class="controls">
              @if (isEditable) {
                <button class="btn" title="Éditer le relevé" (click)="edit(releve)"><fa-icon [icon]="faPen" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_releve_editer"></fa-icon></button>
              }
              @if (isEditable) {
                <app-delete-confirm [message]="'Souhaitez-vous vraiment supprimer ce relevé ?'" (deleted)="delete(releve)" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_releve_supprimer">
                  <button class="btn" title="Supprimer le relevé"><fa-icon [icon]="faTimes"></fa-icon></button>
                </app-delete-confirm>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
}

<ng-template #modalEditReleve>
  <div class="modal-body">
    <app-edit-releve [releve]="editReleve" (releveUpdated)="onUpdate()" [relevesIndividuels]="relevesIndividuels"></app-edit-releve>
  </div>
</ng-template>
